"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyShare = exports.StickyApplyShare = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var trans_1 = __importDefault(require("@/plugins/trans"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var Button_1 = __importStar(require("../../Button"));
var LinkButton_1 = __importDefault(require("../../LinkButton"));
var StickyContext_1 = __importDefault(require("../../context/StickyContext"));
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var ApplyVacancyContext_1 = __importDefault(require("../../context/ApplyVacancyContext"));
var ApplyToolTip_1 = __importDefault(require("./ApplyToolTip"));
function ApplyShare(_a) {
    var vacancyId = _a.vacancyId;
    var updateStickyVacancy = (0, react_1.useContext)(StickyContext_1.default).updateStickyVacancy;
    var handleOpenApplyVacancy = (0, react_1.useContext)(ApplyVacancyContext_1.default).handleOpenApplyVacancy;
    var applyButtonRef = (0, react_1.useRef)(null);
    var buttonCss = (0, Button_1.useButtonCss)({});
    (0, react_1.useEffect)(function () {
        if (!(applyButtonRef === null || applyButtonRef === void 0 ? void 0 : applyButtonRef.current)) {
            return;
        }
        var innerRefCurrent = applyButtonRef.current;
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            updateStickyVacancy(!entry.isIntersecting);
        }, 
        // 80px based on sticky search bar, 500px is based on the motivation field and the apply button
        { rootMargin: '-80px 0px 500px 0px' });
        observer.observe(innerRefCurrent);
        // eslint-disable-next-line consistent-return
        return function () { return observer.unobserve(innerRefCurrent); };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
            display: 'flex',
            alignItems: { md: 'center' },
            flexDirection: { xs: 'column', md: 'row' },
            gap: '12px',
        } }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ type: "button", ref: applyButtonRef, css: buttonCss, id: "apply-in-details", onClick: function () { return handleOpenApplyVacancy(true); } }, { children: trans_1.default.get('buttons.frontend.vacancy.apply_now') })), (0, jsx_runtime_1.jsx)(LinkButton_1.default, __assign({ to: "/vacancies/".concat(vacancyId, "/share"), reloadDocument: true }, { children: trans_1.default.get('buttons.frontend.vacancy.share') })), (0, jsx_runtime_1.jsx)(ApplyToolTip_1.default, { classBox: { ml: 2, display: { xs: 'none', md: 'block' } } })] })));
}
exports.ApplyShare = ApplyShare;
function StickyApplyShare() {
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var _a = (0, react_1.useContext)(StickyContext_1.default), isStickyVacancy = _a.isStickyVacancy, updateStickyVacancy = _a.updateStickyVacancy;
    var handleOpenApplyVacancy = (0, react_1.useContext)(ApplyVacancyContext_1.default).handleOpenApplyVacancy;
    var vacancyParam = (0, react_router_dom_1.useParams)().vacancyId;
    var vacancy = (0, react_query_1.useQuery)(['vacancy', vacancyParam], function () {
        return axios_1.default.get("/data/vacancies/".concat(vacancyParam)).then(function (result) { return result.data; });
    }).data;
    if (!vacancy) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, id: "sticky-apply", sx: {
            display: isStickyVacancy ? 'block' : 'none',
            background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
            padding: 2,
            bottom: 0,
            position: 'sticky',
            zIndex: 5,
        } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                display: 'flex',
                alignItems: { md: 'center' },
                flexDirection: 'row',
                flexWrap: { xs: 'wrap', md: 'no-wrap' },
                justifyContent: { xs: 'center', md: 'unset' },
                margin: { xs: 'unset', md: '0px 2rem 0px 2rem' },
                gap: '12px',
            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { marginRight: 'auto', color: 'white', width: { xs: '100%', md: 'initial' }, fontWeight: 'bold' } }, { children: (0, html_react_parser_1.default)(vacancy.title) })), isSmallScreen && (0, jsx_runtime_1.jsx)(ApplyToolTip_1.default, { classBox: { position: 'absolute', top: '-48px', right: 0 } }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () {
                        handleOpenApplyVacancy(true);
                        updateStickyVacancy(false);
                        window.scrollTo({ top: 0 });
                    } }, { children: trans_1.default.get("buttons.frontend.vacancy.".concat(isSmallScreen ? 'apply' : 'apply_now')) })), (0, jsx_runtime_1.jsx)(LinkButton_1.default, __assign({ to: "/vacancies/".concat(vacancy.id, "/share"), reloadDocument: true }, { children: trans_1.default.get('buttons.frontend.vacancy.share') }))] })) })));
}
exports.StickyApplyShare = StickyApplyShare;
